/**
 * Cidades Convenio
 *      Rotas
 *          - api/estados/{uf}/cidades
 *          - api/convenio/cidades/{estado_id}
 */
import UtilsFael from '@lib/utilsFael'
import Axios from 'axios'
import qs from 'qs'

const STORAGE_NAME = 'latlng_cidades_unidades';

export default class Cidade {
    constructor(cidade, uf) {
        this.__original = cidade
        this.uf = uf
    }

    getCidadeUnidadesFromLocalStorage(slug, uf) {
        try {
            let cidadesUnidades = localStorage.getItem(STORAGE_NAME)
            return JSON.parse(cidadesUnidades).find(cidade => cidade.slug == slug && cidade.uf == uf)
        } catch (error) {
            return null
        }
    }
    
    setCidadeUnidadesToLocalStorage(cidade) {
        try {
            let cidadesUnidades = JSON.parse(localStorage.getItem(STORAGE_NAME))
            cidadesUnidades.push(cidade)
            localStorage.setItem(STORAGE_NAME, JSON.stringify(cidadesUnidades))
        } catch (error) {
            localStorage.setItem(STORAGE_NAME, JSON.stringify([cidade]))
        }
    }

    async setLatLng() {
        let params = {
            address: `${this.nome} - ${this.uf} - Brasil`,
            key: UtilsFael.google_maps_api
        }
        await Axios
            .get(`https://maps.googleapis.com/maps/api/geocode/json?${qs.stringify(params)}`)
            .then(response => {
                if (response.data.results.length) {
                    this.setCidadeUnidadesToLocalStorage({
                        uf: this.uf,
                        slug: this.slug,
                        latlng: response.data.results[0].geometry.location
                    })
                }
            })
    }

    /**
     * @returns {string}
     */
    get id() {
        return this.__original.id || ''
    }

    /**
     * @returns {string}
     */
    get slug() {
        return UtilsFael.slugify(this.nome)
    }

    /**
     * @returns {string}
     */
    get nome() {
        return this.__original.nome || ''
    }

    /**
     * @returns {object}
     */
    get latlng() {
        let cidadeLocal = this.getCidadeUnidadesFromLocalStorage(this.slug, this.uf)
        if (cidadeLocal)
            return cidadeLocal.latlng
        return {}
    }
}